import serialize from 'form-serialize';
import Notifications from '../notifications/notifications';
class Newsletter {
	constructor() {
		this.init();
	}

	init() {
		this.newsletterForm = document.querySelector("[data-nform='newsletter']");

		if (this.newsletterForm) {
			this.bindSubmit();
		}
	}

	bindSubmit() {
		this.newsletterForm.addEventListener('submit', event => {
			event.preventDefault();
			console.log(this.newsletterForm)
			fetch('/umbraco/surface/SubscribeSurface/Subscribe', {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
					'X-Requested-With': 'XMLHttpRequest',
				},
				method: 'POST',
				credentials: 'include',
				body: serialize(this.newsletterForm),
			})
				.then(data => data.json())
				.then(result => {
					if (result) {
						console.log(result)
						Notifications.success("Thank you for joining our mailing list");
						this.newsletterForm.innerHTML = `<h4>Thank you. Your email added to our mailing list.</h4>`;
					} else {
						Notifications.error("Sorry. Your email can't be added to mailing list.");
						this.newsletterForm.innerHTML = `<h4>Sorry. Your email can't be added to mailing list.</h4>`;
					}
				});
		});
	}
}

export default new Newsletter();
